// Module
var code = `<div class="tab-menu" ng-if="!\$ctrl.singlePage">
  <ul class="nav-tabs">
    <li class="active">
      <a data-target="#loan-parameters" data-toggle="tab">
        <span>
          <i ng-show="\$ctrl.formParam.\$invalid || \$ctrl.displayWarningIcon" class="icon icon-warning-sign"></i>
          Loan parameters
        </span>
      </a>
    </li>
    <li ng-if="\$ctrl.isRestructuredLoan() || \$ctrl.isRenewedLoan() || \$ctrl.isReconstructedLoan()">
      <a data-target="#loan-waive" data-toggle="tab" id="waive-link">
        <span ng-if="\$ctrl.isRestructuredLoan()"><i ng-show="\$ctrl.waiveForm.\$invalid" class="icon icon-warning-sign"></i>Restructured loan</span>
        <span ng-if="\$ctrl.isRenewedLoan()"><i ng-show="\$ctrl.waiveForm.\$invalid" class="icon icon-warning-sign"></i>Renewed loan</span>
        <span ng-if="\$ctrl.isReconstructedLoan()"><i ng-show="\$ctrl.waiveForm.\$invalid" class="icon icon-warning-sign"></i>Reconstructed loan</span>
      </a>
    </li>
    <li>
      <a data-target="#loan-information" data-toggle="tab" id="applicants-link">
        <span><i ng-show="formLai.\$invalid" class="icon icon-warning-sign"></i>Loan account information</span>
      </a>
    </li>
    <li ng-if="\$ctrl.isConsolidatedLoan()">
      <a data-target="#consolidated-form" data-toggle="tab" id="consolidated-loans">
        <i ng-show="\$ctrl.consolidationForm.\$invalid" class="icon icon-warning-sign"></i>Consolidated loans</span>
      </a>
    </li>
    <li>
      <a data-target="#loan-documents" data-toggle="tab" id="documents-link">
        <span><i ng-show="\$ctrl.loanDocumentsForm.\$invalid" class="icon icon-warning-sign"></i>Loan documents</span>
      </a>
    </li>
    <li>
      <a data-target="#loan-override" data-toggle="tab" id="override-link" ng-if="!\$ctrl.isReconstructedLoan()">
          <span title="{{\$ctrl.feesAutoUpdated}}">
            <i ng-show="overrideForm.\$invalid || \$ctrl.overrideError" class="icon icon-warning-sign"></i>
            <i ng-show="!overrideForm.\$invalid && \$ctrl.feesAutoUpdated" class="icon icon-info-sign icon-orange"></i>
            Loan charges override
          </span>
      </a>
    </li>

    <li ng-if="\$ctrl.loan.customerId">
      <a data-target="#co-makers" data-toggle="tab">
        <span><i ng-show="\$ctrl.coMakersForm.\$invalid" class="icon icon-warning-sign"></i>Co-Makers</span>
      </a>
    </li>
  </ul>
</div>

<div class="tab-content">

  <div ng-class="{'tab-pane active': !\$ctrl.singlePage}" id="loan-parameters">
    <div class="form-header no-print" ng-if="\$ctrl.singlePage">Loan parameters</div>
    <customer-loan-create-parameters
      ng-if="\$ctrl.loanProduct"
      form-param="\$ctrl.formParam"
      customer-id="\$ctrl.loan.customerId"
      loan="\$ctrl.loan"
      loan-product="\$ctrl.loanProduct"@
      group-loan="false"
      override-dates="\$ctrl.shouldOverrideDates()"
      edit-mode="\$ctrl.isEditModeEnabled()"
      on-warning-updated="\$ctrl.onWarningUpdated">
    </customer-loan-create-parameters>
  </div>

  <div ng-class="{'tab-pane': !\$ctrl.singlePage}" id="loan-waive" ng-if="\$ctrl.isRestructuredLoan() || \$ctrl.isRenewedLoan() || \$ctrl.isReconstructedLoan()">
    <loan-pre-terminate
      form-name="\$ctrl.waiveForm"
      max-values="\$ctrl.loan.existingAmortizationSchedule.totalBalance"
      waive-request="\$ctrl.loan.waiveRequest"
      payment-request="\$ctrl.empty"
      loan="\$ctrl.loan.sourceLoan">
    </loan-pre-terminate>
  </div>

  <div ng-class="{'tab-pane': !\$ctrl.singlePage}" id="loan-override" ng-if="!\$ctrl.isReconstructedLoan()">
    <customer-loan-charges-override
      form-name="overrideForm"
      loan="\$ctrl.loan"
      loan-product="\$ctrl.loanProduct"
      override-required="true"
      category-ids="\$ctrl.loan.categoryIds"
      custom-field-values="\$ctrl.loan.customFieldValues"
      on-updated="\$ctrl.onFeesAutoUpdated"
      edit-mode="\$ctrl.isEditModeEnabled()">
    </customer-loan-charges-override>
  </div>

  <div ng-class="{'tab-pane': !\$ctrl.singlePage}" id="loan-information">
    <customer-loan-create-lai-details
      form-lai="formLai"
      customer-id="\$ctrl.loan.customerId"
      loan-information="\$ctrl.loan.loanInformation"
      loan-collaterals="\$ctrl.loan.collaterals"
      loan-product="\$ctrl.loanProduct"
      category-ids="\$ctrl.loan.categoryIds"
      custom-field-values="\$ctrl.loan.customFieldValues"
      branch-id="\$ctrl.loan.branchId"
      edit-mode="\$ctrl.isEditModeEnabled()">
    </customer-loan-create-lai-details>
  </div>

  <div ng-class="{'tab-pane': !\$ctrl.singlePage}" id="consolidated-form" ng-if="\$ctrl.isConsolidatedLoan()">
    <ng-form name="\$ctrl.consolidationForm">
      <loan-consolidation loan="\$ctrl.loan">
      </loan-consolidation>
    </ng-form>

  </div>

  <div ng-class="{'tab-pane': !\$ctrl.singlePage}" id="loan-documents">
    <ng-form name="\$ctrl.loanDocumentsForm">
      <loan-documents loan="\$ctrl.loan"></loan-documents>
    </ng-form>
  </div>

  <div ng-class="{'tab-pane': !\$ctrl.singlePage}" id="co-makers" ng-if="\$ctrl.loan.customerId">
    <customer-loan-co-makers
      form="\$ctrl.coMakersForm"
      loan="\$ctrl.loan"
      edit-mode="\$ctrl.isEditModeEnabled()">
    </customer-loan-co-makers>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/page/details/customer-loan-create-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;